// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__v9FKw","singleLine":"header_singleLine__1NaS4"};